export function formatNumberShorthand(num: number | null | undefined, fallback = '0'): string {
  if (num == null) {
    return fallback;
  }

  if (num >= 1000000) {
    const millions = num / 1000000;
    return (Math.floor(millions * 10) / 10).toFixed(1) + 'M'; // Ensures one decimal place, e.g., 1.0M or 1.5M
  } else if (num >= 1000) {
    const thousands = num / 1000;
    return (Math.floor(thousands * 10) / 10).toFixed(1) + 'k'; // Ensures one decimal place, e.g., 1.0k or 1.5k
  }

  return num.toString();
}
